import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

//axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const instanceAxios1 = axios.create({});
instanceAxios1.defaults.baseURL = process.env.REACT_APP_API_URL;

instanceAxios1.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

function setJwt(jwt) {
  instanceAxios1.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  get: instanceAxios1.get,
  post: instanceAxios1.post,
  put: instanceAxios1.put,
  delete: instanceAxios1.delete,
  setJwt
};
